import './styles.scss';

export { WorkoutCaloriesBurnt } from './WorkoutCaloriesBurnt';
export { WorkoutIntro } from './WorkoutIntro';
export { WorkoutList } from './WorkoutList';
export { WorkoutMeta } from './WorkoutMeta';
export { WorkoutRatings } from './WorkoutRatings';
export { WorkoutSection } from './WorkoutSection';



// WEBPACK FOOTER //
// ./src/components/Workout/index.js